import { useQuery } from "@tanstack/react-query";
import { getCurrentUser } from "../api/auth.js";
import { ApiCallError } from "../api/client.js";
import type { User } from "../api/types.js";

export interface SessionState {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  isError: boolean;
  impersonating: string | null;
}

export function useSession(): SessionState {
  const { data, isLoading, isError } = useQuery<User, ApiCallError>({
    queryKey: ["session"],
    queryFn: getCurrentUser,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    user: data ?? null,
    isLoading,
    isAuthenticated: data != null,
    isError,
    impersonating: data?.impersonating ?? null,
  };
}
